import * as CL from '@design-system/component-library';
import { dsClass } from '../../common/constants/dsClasses.js';
import { activationFeeMsg, startingAtMsg, sumPerMonthMsg, t } from '../../common/i18n/index.js';
import { formatSum } from '../../common/utils/priceUtils.js';
import { ToggleCheckbox } from '../ToggleCheckbox/ToggleCheckbox.js';
import type { OnlineModel } from '../../generated/api/models.js';
import type { YritystuplaOfferSelection } from '../FixedBroadbandCheckout/FixedBroadbandCheckout.js';

import './YritysTuplaSelection.scss';

interface YritystuplaSelectionProps {
  model: OnlineModel;
  yritystuplaOffer: YritystuplaOfferSelection;
  onChange: (selection: YritystuplaOfferSelection) => void;
}

export const YritystuplaSelection = ({ model, onChange, yritystuplaOffer }: YritystuplaSelectionProps) => {
  const { enabled, selectedOffer } = yritystuplaOffer;
  const sortedOffers = model.offers
    .filter(offer => offer?.commercialProducts[0].price?.effectivePrice.monthlyRecurringCharge !== undefined)
    .sort(
      (a, b) =>
        // The filter above checks that the prices truly exist here
        b.commercialProducts[0].price!.effectivePrice.monthlyRecurringCharge! -
        a.commercialProducts[0].price!.effectivePrice.monthlyRecurringCharge!
    );

  if (!selectedOffer && !sortedOffers[0]) {
    return <></>;
  }

  const cheapestPrice =
    sortedOffers[sortedOffers.length - 1]?.commercialProducts[0]?.price?.effectivePrice?.monthlyRecurringCharge;

  const priceInfo = {
    value: `${t.OD1L(startingAtMsg)} ${t.YO7F(sumPerMonthMsg, formatSum(cheapestPrice) || '')}`,
  };

  const onOfferChange = (newOfferCode: string) => {
    const offer = sortedOffers.find(o => o.offerCode === newOfferCode);
    onChange({ enabled: true, selectedOffer: offer });
  };

  return (
    <ToggleCheckbox
      title={t.LKVJ('Order a mobile broadband subscription as well – with up to 67% off')}
      initialValue={enabled}
      additionalInformation={t.ZCA8(
        'You can get a mobile broadband subscription with up to 67% discount with no fixed-term commitment when you order Netti Lite. Take advantage of the offer and see the available options.'
      )}
      onChange={(checked: boolean) => {
        onChange({ enabled: checked, selectedOffer: selectedOffer || sortedOffers[0] });
      }}
      priceInfo={priceInfo}
    >
      <div className="of-fixed-bb-yritystupla__price">
        <CL.RadioGroup
          onChange={onOfferChange}
          value={selectedOffer?.offerCode || sortedOffers[0].offerCode}
          disabled={!enabled}
        >
          {sortedOffers.map(offer => (
            <CL.RadioV2 className="of-fixed-bb-yritystupla__radio" key={offer.offerCode} value={offer.offerCode}>
              <div
                className={`${dsClass.DISPLAY_FLEX} ${dsClass.JUSTIFY_CONTENT_SPACE_BETWEEN} of-fixed-bb-yritystupla__radio-label`}
              >
                <div>
                  <div>{offer.offerName}</div>
                  <div className={dsClass.TEXT_XS}>
                    {`${t.HWDR(activationFeeMsg)} ${formatSum(
                      offer.commercialProducts[0].price?.effectivePrice.oneTimeCharge
                    )}`}
                  </div>
                </div>
                <div className={dsClass.PADDING_LEFT_2}>
                  {t.YO7F(
                    sumPerMonthMsg,
                    formatSum(offer.commercialProducts[0].price?.effectivePrice.monthlyRecurringCharge)!
                  )}
                </div>
              </div>
            </CL.RadioV2>
          ))}
        </CL.RadioGroup>
      </div>
    </ToggleCheckbox>
  );
};
